// updates data to send values based on each input change
import { AxiosInstance } from "axios";
import { NavigateFunction } from "react-router-dom";
import { toast } from "react-toastify";
import { Predicates } from "../../../libraries/predicates/predicates";
import { MasterArtworkCollectionActions } from "../../../states/meta-artwork/collections";
import { MasterArtworkNameActions } from "../../../states/meta-artwork/artwork-name";
import { MasterArtworkNumberActions } from "../../../states/meta-artwork/artwork-number";
import { MasterArtworkPrintingTechniqueActions } from "../../../states/meta-artwork/printing-technique";

export enum actionsList {
  "CREATED" = "CREATED",
  "SUBMITTED" = "SUBMITTED",
  "REJECTED" = "REJECTED",
  "APPROVED" = "APPROVED",
  "EDITED" = "EDITED",
  "SELECTED" = "SELECTED",
  "DELETED" = "DELETED",
}

type ValueOrNull<T> = T | null;

export function processRequestErrorIntoErrorToast(error: any) {
  const errorMessages = Object.values(error.response.data).flat() as string[];
  errorMessages.length > 0 && errorMessages.length < 10
    ? errorMessages.forEach((errorMessage) => toast.error(errorMessage))
    : toast.error("An unknown error occurred. Contact support.");
}

export const saveRequest = (x: any, c: any, v: any, b: any, n: any) => {};

export interface IGenericRequest {
  requestId: any | null;
  action: keyof typeof actionsList;
  action_user: string;
  context: number;
  country: number;
  data: string;
  reason: ValueOrNull<number>;
  comment: string;
}

export const submitCollectionRequest = async (
  axios: AxiosInstance,
  request: IGenericRequest,
  username: string,
  dispatch: any,
  setIsInProgress: (isLoading: boolean) => void,
  navigate: NavigateFunction,
  navigateUrl: string,
  navigateReplace: boolean,
) => {
  const requestHasId = Predicates.isNotNullAndNotUndefinedAndNotEmpty(
    request.requestId?.toString(),
  );

  const method = requestHasId ? "put" : "post";
  const requestUrl = requestHasId
    ? `/request/${request.requestId}/`
    : `/request/`;

  try {
    setIsInProgress(true);
    const response = await axios({
      method: method,
      url: requestUrl,
      data: {
        action: actionsList[request.action],
        action_user: username,
        context: request.context,
        data: request.data,
        country: request.country,
        comment: request.comment,
        reason: request.reason,
      },
    });

    dispatch(MasterArtworkCollectionActions.setUnsavedChanges(false));
    dispatch(MasterArtworkCollectionActions.resetState());

    dispatch(MasterArtworkNameActions.setUnsavedChanges(false));
    dispatch(MasterArtworkNameActions.resetState());

    dispatch(MasterArtworkNumberActions.setUnsavedChanges(false));
    dispatch(MasterArtworkNumberActions.resetState());

    dispatch(MasterArtworkPrintingTechniqueActions.setUnsavedChanges(false));
    dispatch(MasterArtworkPrintingTechniqueActions.resetState());

    toast.success(`Request ${response.data.id} ${request.action} successfully`);

    setIsInProgress(false);
    // navigate("/artwork-master/collections", { replace: true });
    navigate(`${navigateUrl}`, { replace: navigateReplace });
  } catch (err) {
    console.error(err);
    processRequestErrorIntoErrorToast(err);
    setIsInProgress(false);
  }
};

export const submitCollectionEditRequest = async (
  axios: AxiosInstance,
  id: string | number,
  data: any,
) => {
  const requestUrl = `artwork-master/collections/${id}/`;

  const collectionUpdateDTO = {
    // id: data.id,
    name: data.name,
    code: data.code,
    licensor: data.licensor.id,
    licensed_property: data.licensed_property.id,
    launch_date: data.launch_date,
    global_product: data.global_product,
  };


  const response = await axios({
    method: "patch",
    url: requestUrl,
    data: collectionUpdateDTO,
  })

  return response;
};
